import { render, staticRenderFns } from "./goodsDispatchDetails.vue?vue&type=template&id=751fd390&scoped=true&"
import script from "./goodsDispatchDetails.vue?vue&type=script&lang=ts&"
export * from "./goodsDispatchDetails.vue?vue&type=script&lang=ts&"
import style0 from "./goodsDispatchDetails.vue?vue&type=style&index=0&id=751fd390&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751fd390",
  null
  
)

export default component.exports